<files-download-package-type-component
    [actions]="actions"
    [downloadAction]="modalData.downloadAction"
    [allowedPackageTypes]="modalData.allowedPackageTypes || []"
    [(selectedPackageType)]="selectedPackageType">
</files-download-package-type-component>
